/**
 * Specifies Workbook internal events.
 */
/** @hidden */
export var workbookDestroyed = 'workbookDestroyed';
/** @hidden */
export var updateSheetFromDataSource = 'updateSheetFromDataSource';
/** @hidden */
export var dataSourceChanged = 'dataSourceChanged';
/** @hidden */
export var workbookOpen = 'workbookOpen';
/** @hidden */
export var beginSave = 'beginSave';
/** @hidden */
export var saveCompleted = 'saveCompleted';
/** @hidden */
export var applyNumberFormatting = 'applyNumber';
/** @hidden */
export var getFormattedCellObject = 'getFormattedCell';
/** @hidden */
export var refreshCellElement = 'refreshCellElem';
/** @hidden */
export var setCellFormat = 'setCellFormat';
/** @hidden */
export var textDecorationUpdate = 'textDecorationUpdate';
/** @hidden */
export var applyCellFormat = 'applyCellFormat';
/** @hidden */
export var updateUsedRange = 'updateUsedRange';
/** @hidden */
export var workbookFormulaOperation = 'workbookFormulaOperation';
/** @hidden */
export var workbookEditOperation = 'workbookEditOperation';
/** @hidden */
export var checkDateFormat = 'checkDateFormat';
/** @hidden */
export var getFormattedBarText = 'getFormattedBarText';
/** @hidden */
export var activeCellChanged = 'activeCellChanged';
/** @hidden */
export var openSuccess = 'openSuccess';
/** @hidden */
export var openFailure = 'openFailure';
/** @hidden */
export var sheetCreated = 'sheetCreated';
/** @hidden */
export var sheetsDestroyed = 'sheetsDestroyed';
/** @hidden */
export var aggregateComputation = 'aggregateComputation';
/** @hidden */
export var beforeSort = 'beforeSort';
/** @hidden */
export var initiateSort = 'initiateSort';
/** @hidden */
export var sortComplete = 'sortComplete';
/** @hidden */
export var sortRangeAlert = 'sortRangeAlert';
/** @hidden */
export var initiatelink = 'initiatelink';
/** @hidden */
export var beforeHyperlinkCreate = 'beforeHyperlinkCreate';
/** @hidden */
export var afterHyperlinkCreate = 'afterHyperlinkCreate';
/** @hidden */
export var beforeHyperlinkClick = 'beforeHyperlinkCreate';
/** @hidden */
export var afterHyperlinkClick = 'afterHyperlinkCreate';
/** @hidden */
export var addHyperlink = 'addHyperlink';
/** @hidden */
export var setLinkModel = 'setLinkModel';
/** @hidden */
export var beforeFilter = 'beforeFilter';
/** @hidden */
export var initiateFilter = 'initiateFilter';
/** @hidden */
export var filterComplete = 'filterComplete';
/** @hidden */
export var filterRangeAlert = 'filterRangeAlert';
/** @hidden */
export var clearAllFilter = 'clearAllFilter';
